import { Component, Input } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { ReplaceLineBreaksPipe } from 'src/app/replace-line-breaks.pipe';
import { PortInfoService } from 'src/app/Services/port-info.service';
import * as moment from 'moment';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type PortInfo = {
  poc: string;
  itibegdate: Date;
  itiEndDate: Date;

  itiName: string;
  itiComments: string;
  gpiCity: string;
  gpiState: string;
  gpiDescription: string;
  gpiImage: string;
};

@Component({
  selector: 'app-dock-address-expander',
  templateUrl: './dock-address-expander.component.html',
  styleUrls: ['./dock-address-expander.component.css'],
  providers: [PortInfoService],
})
export class DockAddressExpanderComponent {
  @Input() inputdate: string | undefined;
  currentdate: string | undefined;
  expandDockaddress = true;
  userdata?: UserData;
  bookingCode: string | undefined;
  evtCode: string | undefined;
  OBPortalSvcURL = '';
  boardingDate: Date | undefined;

  PortInfo: PortInfo | undefined;
  portdata: any;

  constructor(
    private appConfigService: AppConfigService,
    private PortInfoService: PortInfoService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.bookingCode = this.userdata?.rebcode!;
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);

    this.getPortInfo();
  }
  getPortInfo() {
    if (this.inputdate == '') {
      this.currentdate = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    else {
      this.currentdate = moment(this.inputdate).format('YYYY-MM-DD HH:mm:ss');
    }
    this.portdata = this.PortInfoService.getPortInfo(
      this.evtCode,
      this.currentdate
    ).subscribe((portdata) => this.setPortInfo(portdata));
  }
  setPortInfo(resdata: any) {
    this.portdata = resdata;
    if (this.portdata.GetCruisePort.Result.Status == 'A') {
      this.PortInfo = this.portdata.GetCruisePort.CruisePort;
      if (this.PortInfo?.itiComments != undefined) {
        this.PortInfo.itiComments = this.PortInfo?.itiComments.replace(
          '|',
          ' \n'
        );
      }
    }
  }
}
